import { Logger } from '../utils/logger';
export class FormService {
    /**
     * Register hidden input callback for a specific content ID
     * @param args
     */
    static registerHiddenInputCallback(args) {
        const callback = () => {
            this.addHiddenInputs(args);
        };
        // content id is not passed for document level loading
        const id = args.type !== 'document'
            ? args.contentId.toString()
            : args.formId.toString();
        this.hiddenInputCallbacks[id] = callback;
        Logger.debug(`Registered hidden input callback for content ID: ${id}`);
    }
    /**
     * Add hidden inputs to form
     * @param args
     * @private
     */
    static addHiddenInputs(args) {
        const { formId, postId } = args;
        // const contentId = args.type !== 'document' ? args.contentId : null;
        const formSelector = `#gform_${formId}`;
        const form = jQuery(formSelector);
        if (form.length === 0) {
            Logger.warn(`Form with ID ${formId} not found`);
            return;
        }
        const footer = form.find('.gform-footer');
        if (footer.length === 0) {
            Logger.warn(`Form footer not found for form ${formId}`);
            return;
        }
        // Add post ID input
        const postIdInputId = args.type !== 'document'
            ? `gpsa_document_access_post_id_${args.contentId}`
            : 'gpsa_document_access_post_id';
        footer.append(`<input type="hidden" id="${postIdInputId}" name="gpsa_document_access_post_id" value="${postId}">`);
        if (args.type === 'block') {
            const contentIdInputId = `gpsa_document_access_content_id_${args.contentId}`;
            footer.append(`<input type="hidden" id="${contentIdInputId}" name="gpsa_document_access_content_id[]" value="${args.contentId}">`);
        }
        else if (args.type === 'shortcode') {
            const encryptedShortcodeInputId = `gpsa_document_access_content_id_${args.contentId}`;
            footer.append(`<input type="hidden" id="${encryptedShortcodeInputId}" name="gpsa_document_access_encrypted_shortcode[]" value="${args.encryptedShortcode}">`);
        }
        Logger.debug(`Added hidden inputs to form ${formId}`, {
            ...args,
        });
    }
    /**
     * Initialize Gravity Forms integration
     */
    static initializeGravityFormsIntegration() {
        if (typeof window.gform !== 'undefined' &&
            window.gform.utils &&
            window.gform.utils.addAsyncFilter) {
            window.gform.utils.addAsyncFilter('gform/submission/pre_submission', async (data) => {
                // Execute all registered callbacks
                Object.values(this.hiddenInputCallbacks).forEach((callback) => {
                    try {
                        callback();
                    }
                    catch (error) {
                        Logger.error('Error executing hidden input callback', error);
                    }
                });
                return data;
            });
            Logger.debug('Gravity Forms pre-submission filter registered');
        }
        else {
            Logger.warn('Gravity Forms utils not available for filter registration');
        }
    }
    /**
     * Execute hidden input callback for specific content
     * @param contentId
     */
    static executeHiddenInputCallback(contentId) {
        const callback = this.hiddenInputCallbacks[contentId.toString()];
        if (callback) {
            try {
                callback();
                Logger.debug(`Executed hidden input callback for content ID: ${contentId}`);
            }
            catch (error) {
                Logger.error(`Error executing hidden input callback for content ID: ${contentId}`, error);
            }
        }
        else {
            Logger.warn(`No hidden input callback found for content ID: ${contentId}`);
        }
    }
    /**
     * Clear callback for content ID
     * @param contentId
     */
    static clearCallback(contentId) {
        delete this.hiddenInputCallbacks[contentId.toString()];
        Logger.debug(`Cleared hidden input callback for content ID: ${contentId}`);
    }
}
FormService.hiddenInputCallbacks = {};
